export default __webpack_public_path__ + "static/media/marauders-map-v4-04-01.d8d15398.jpg";